<template>
    <v-flex class="organization" fluid>
        <change-admin-modal v-if="currentOrgId !== ''" :dialog.sync="changeAdminDialog" :item="item" :organizationId="currentOrgId"></change-admin-modal>
        <remove-user-modal v-if="currentOrgId !== ''" :dialog.sync="removeUserDialog" :item="item" :organizationId="currentOrgId"></remove-user-modal>
        <leave-organization-modal v-if="currentOrgId !== ''" v-on:leave-org-event="reloadInfo" :dialog.sync="leaveOrganizationDialog" :user="User" :organizationId="currentOrgId"></leave-organization-modal>
        <remove-organization-modal v-if="hasOrganization" v-on:remove-org-event="reloadInfo" :dialog.sync="removeOrganizationDialog" :organization="User.Organization.find(org => org.id === currentOrgId)"></remove-organization-modal>
        <app-snackbar
          :text = "snackBarText"
          :show.sync = "snackbar"
          :color = "snackbarColor"
          :timeOut = "timeOut"
        ></app-snackbar>
        <v-flex xs12 sm6 offset-sm3 fill-height>
            <p class="font title"><b>Organizaciones</b></p>
            <div v-if="hasOrganization">
              <v-text-field style="width: 87%" v-if="isAdmin(User)" class="font input-text" :readonly="!isNameEditable" prepend-inner-icon="domain" :append-icon="iconEdit" @click:append="editName" name="name" label="Nombre de la organización"
                  v-model="organizationName"
                  type="name"
                  color="0099E1"
              ></v-text-field>
              <p v-else class="font org-name"><v-icon color="black">domain</v-icon> {{ this.organizationName }} </p>
              <v-menu
                left
                transition="slide-y-transition"
                style="float: right; margin-top: -58px"
              >
                <v-btn icon slot="activator">
                  <v-icon color="#7A7B7B">arrow_drop_down</v-icon>
                </v-btn>
                <v-list>
                  <template v-for="item in organizationsItems">
                    <v-list-tile
                      :key="item.id"
                      @click="selectOrganization(item)"
                      append
                    >
                      <v-list-tile-title>{{item.name}}</v-list-tile-title>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-menu>
            </div>
            <p v-else class="font org-name"><v-icon color="black">domain</v-icon> Sin organización </p>
            <div class="div-create-org">
              <img class="icon" :src="require('../../assets/icons/add-organization.png')"/>
              <a class="font create-org-button" @click="newOrganizationButton">Nueva organización</a>
            </div>
            <div v-if="hasOrganization">
                <p class="font title"><b>Integrantes</b></p>
                <v-list class="v-list">
                    <v-list-tile
                        v-for="item in usersAdminItems"
                        :key="item.id">
                        <v-icon color="black">person</v-icon>
                        <v-list-tile-content class="v-list-content">
                            {{ item.name }} <span class="font-light">- Administrador</span>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <v-list class="v-list">
                    <v-list-tile
                        v-for="item in membersItems"
                        :key="item.id"
                        v-show="!isAdmin(item)"
                    >
                        <v-icon color="black">person</v-icon>
                        <v-list-tile-content class="v-list-content"> {{ item.name }} </v-list-tile-content>
                        <v-menu v-if="isAdmin(User)">
                          <v-btn icon slot="activator">
                            <v-icon color="#7A7B7B">more_vert</v-icon>
                          </v-btn>
                          <v-list>
                            <v-list-tile @click="removeMember(item)">
                              <v-list-tile-title>Eliminar</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="makeAdmin(item)">
                              <v-list-tile-title>Hacer Administrador</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                    </v-list-tile>
                </v-list>
                <div class="div-padding-left" v-if="isAdmin(User)">
                    <v-icon class="valid-button">person_add</v-icon>
                    <a class="font invite-text valid-button" @click="inviteButton()">Invitar integrante</a>
                </div>
                <p class="font title"><b>Equipos de Riego</b></p>
                <v-list class="v-list" v-if="devicesItems && devicesItems.length">
                    <v-list-tile
                        v-for="item in devicesItems"
                        :key="item.name"
                    >
                        <v-icon color="black">track_changes</v-icon>
                        <v-list-tile-content class="v-list-content">{{ item.name }}</v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <div v-else class="align-center">
                    <p class="font sin-equipos-text">NO HAY EQUIPOS REGISTRADOS</p>
                </div>
                <div class="div-create-device" v-if="isAdmin(User)">
                    <img class="vertical-align-middle create-device-icon" :src="getCreateDeviceIcon()"/>
                    <a class="font create-device-text valid-button" @click="createDeviceButton">Agregar equipo de riego</a>
                </div>
                <div class="div-manage-org-btn">
                    <a v-if="isAdmin(User)" class="font manage-org-button" @click="manageOrganization"><u>Eliminar organización</u></a>
                    <a v-else class="font manage-org-button" @click="manageOrganization"><u>Abandonar organización</u></a>
                </div>
            </div>
        </v-flex>
    </v-flex>
</template>

<script>
  import { UPDATE_ORGANIZATION_MUTATION, USER_QUERY } from '../../constants/graphql';
  import RemoveUserModal from './RemoveUserModal.vue';
  import ChangeAdminModal from './ChangeAdminModal.vue';
  import LeaveOrganizationModal from './LeaveOrganizationModal.vue';
  import RemoveOrganizationModal from './RemoveOrganizationModal.vue';

  export default {
    props: ['firstEntry', 'deviceCreated', 'organizationCreated'],
    data () {
      return {
        User: {
          Organization: {
            User: [],
            Admin: [],
            Device: []
          }
        },
        nameAux: '',
        devices: [],
        snackbar: false,
        snackBarText: '',
        snackbarColor: '',
        timeOut: 5000,
        removeUserDialog: false,
        changeAdminDialog: false,
        leaveOrganizationDialog: false,
        removeOrganizationDialog: false,
        item: {},
        isNameEditable: false,
        currentOrgId: '',
        organizationName: ''
      };
    },
    apollo: {
      User: {
        query: USER_QUERY,
        variables () {
          return {
            id: this.$store.getters.user.id
          };
        }
      }
    },
    computed: {
      iconEdit () {
        if (this.isNameEditable) {
          return 'check';
        } else {
          return 'edit';
        }
      },
      usersAdminItems () {
        return this.User.Organization.find(org => org.id === this.currentOrgId).Admin;
      },
      membersItems () {
        return this.User.Organization.find(org => org.id === this.currentOrgId).User;
      },
      devicesItems () {
        return this.User.Organization.find(org => org.id === this.currentOrgId).Device;
      },
      organizationsItems () {
        return this.User.Organization.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        });
      },
      hasOrganization () {
        if (this.User.Organization && this.User.Organization.length) {
          if (this.currentOrgId === '') {
            this.currentOrgId = this.User.Organization[0].id;
          }
          this.organizationName = this.User.Organization.find(org => org.id === this.currentOrgId).name;
          return true;
        } else {
          return false;
        }
      }
    },
    created () {
      mixpanel.track('/organization');
      gtag('config', 'GA_MEASUREMENT_ID', {
        'page_title': 'Organization',
        'page_path': '/organization'
      });
      if (this.firstEntry) {
        this.snackbar = true;
        this.snackBarText = 'Cuenta creada exitosamente!';
        this.snackbarColor = '#0098E1';
      } else if (this.deviceCreated) {
        this.snackbar = true;
        this.snackBarText = 'Equipo creado exitosamente!';
        this.snackbarColor = '#0098E1';
      } else if (this.organizationCreated) {
        this.snackbar = true;
        this.snackBarText = 'Organización creada exitosamente!';
        this.snackbarColor = '#0098E1';
      }
    },
    watch: {
      currentOrgId () {
      }
    },
    methods: {
      newOrganizationButton () {
        if (this.$store.getters.isOnline) {
          this.$router.push({name: 'NewOrganization'});
        } else {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
        }
      },
      isAdmin (user) {
        if (this.User.Organization.find(org => org.id === this.currentOrgId).Admin) {
          for (const elem of this.User.Organization.find(org => org.id === this.currentOrgId).Admin) {
            if (elem.id === user.id) {
              return true;
            }
          }
          return false;
        }
      },
      inviteButton () {
        if (this.$store.getters.isOnline) {
          const hash = this.User.Organization.find(org => org.id === this.currentOrgId).hash;
          window.open(
            `https://api.whatsapp.com/send?text=Estoy monitoreando los equipos de riego con PONCE y quiero invitarte a formar parte de mi organización para que puedas verlos. %0A %0A Descargala y sumate a mi organización con el siguiente código: %0A *${hash}* %0A ${process.env.VUE_APP_APP_SENSORLESS_URL}`,
          '_blank'
          );
        } else {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
        }
      },
      selectOrganization (item) {
        this.currentOrgId = item.id;
      },
      editName () {
        if (this.$store.getters.isOnline) {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
          return;
        }
        if (!this.isNameEditable) {
          this.isNameEditable = true;
          this.nameAux = this.organizationName;
          return;
        }
        if (this.organizationName && this.organizationName.length && this.organizationName !== this.nameAux) {
          this.$apollo.mutate({
            mutation: UPDATE_ORGANIZATION_MUTATION,
            variables: {
              id: this.currentOrgId,
              name: this.organizationName
            }
          }).then(() => {
            this.snackbar = true;
            this.snackBarText = 'El nombre fue cambiado con éxito';
            this.snackbarColor = 'green';
            this.isNameEditable = false;
          }).catch(() => {
            this.snackbar = true;
            this.snackBarText = 'Ha ocurrido un error';
            this.snackbarColor = 'red';
          });
        } else if (this.organizationName && this.organizationName.length) {
          this.snackbar = true;
          this.snackBarText = 'El nombre debe ser distinto al anterior';
          this.snackbarColor = 'red';
          this.organizationName = this.nameAux;
          this.isNameEditable = false;
        } else {
          this.snackbar = true;
          this.snackBarText = 'El campo Nombre no puede quedar vacío';
          this.snackbarColor = 'red';
          this.organizationName = this.nameAux;
          this.isNameEditable = false;
        }
      },
      createDeviceButton () {
        const orgId = this.currentOrgId;
        this.$router.push({ name: 'Device', params: { orgId } });
      },
      getCreateDeviceIcon () {
        return require('../../assets/icons/add-device-valid.png');
      },
      removeMember (item) {
        if (this.$store.getters.isOnline) {
          this.item = item;
          this.removeUserDialog = true;
        } else {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
        }
      },
      makeAdmin (item) {
        if (this.$store.getters.isOnline) {
          this.item = item;
          this.changeAdminDialog = true;
        } else {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
        }
      },
      manageOrganization () {
        if (this.$store.getters.isOnline) {
          if (!this.isAdmin(this.User)) {
            this.leaveOrganizationDialog = true;
          } else {
            this.removeOrganizationDialog = true;
          }
        } else {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
        }
      },
      reloadInfo () {
        this.$apollo.queries.User.refresh();
      }
    },
    components: {
      'remove-user-modal': RemoveUserModal,
      'leave-organization-modal': LeaveOrganizationModal,
      'change-admin-modal': ChangeAdminModal,
      'remove-organization-modal': RemoveOrganizationModal
    }
  };
</script>


// WEBPACK FOOTER //
// Organization.vue?2c67bb5e